export default "__VITE_ASSET__Hy2GHudb__"